/**
 * Event for configuration iframe integration
 *
 * @category ConfigurationEvent
 */
export var ConfigurationChildEventId;
(function (ConfigurationChildEventId) {
    /**
     * A new configuration has started
     */
    ConfigurationChildEventId["ConfigurationStart"] = "configuration-started";
    /**
     * The configuration has loaded from a saved state
     */
    ConfigurationChildEventId["ConfigurationLoad"] = "configuration-loaded";
    /**
     * The configuration has been resumed from a existing session
     */
    ConfigurationChildEventId["ConfigurationResume"] = "configuration-resumed";
    /**
     * The configuration has changed
     */
    ConfigurationChildEventId["ConfigurationChange"] = "configuration-changed";
    /**
     * The configuration has changed to a different configuration object
     */
    ConfigurationChildEventId["ConfigurationNavigation"] = "configuration-navigation";
})(ConfigurationChildEventId || (ConfigurationChildEventId = {}));
/**
 * A new configuration has started
 *
 * See {@linkcode ConfigurationChildEventId.ConfigurationStart}
 *
 * @category ConfigurationEvent
 */
export class ConfigurationStartEvent {
    constructor(sessionId) {
        this.cfgEvent = ConfigurationChildEventId.ConfigurationStart;
        this.sessionId = sessionId;
    }
}
/**
 * The configuration has loaded from a saved state
 *
 * See {@linkcode ConfigurationChildEventId.ConfigurationLoad}
 *
 * @category ConfigurationEvent
 */
export class ConfigurationLoadEvent {
    constructor(sessionId) {
        this.cfgEvent = ConfigurationChildEventId.ConfigurationLoad;
        this.sessionId = sessionId;
    }
}
/**
 * A new configuration has been resumed from an existing session
 *
 * See {@linkcode ConfigurationChildEventId.ConfigurationResume}
 *
 * @category ConfigurationEvent
 */
export class ConfigurationResumeEvent {
    constructor(sessionId) {
        this.cfgEvent = ConfigurationChildEventId.ConfigurationResume;
        this.sessionId = sessionId;
    }
}
/**
 * Configuration has changed
 * - value was set
 * - configuration reset
 * - substructure added, removed, copied, moved, changed
 *
 * See {@linkcode ConfigurationChildEventId.ConfigurationChange}
 *
 * @category ConfigurationEvent
 */
export class ConfigurationChangeEvent {
    constructor(sessionId) {
        this.cfgEvent = ConfigurationChildEventId.ConfigurationChange;
        this.sessionId = sessionId;
    }
}
/**
 * The configuration has changed to a different configuration object
 * - value was set
 * - configuration reset
 * - substructure changes
 *
 * See {@linkcode ConfigurationChildEventId.ConfigurationNavig}
 *
 * @category ConfigurationEvent
 */
export class ConfigurationNavigationEvent {
    constructor(sessionId, path) {
        this.cfgEvent = ConfigurationChildEventId.ConfigurationNavigation;
        this.sessionId = sessionId;
        this.path = path;
    }
}
//# sourceMappingURL=ConfigurationChildEvent.js.map